import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import MobileHeaderwithCancleFunction from "@/_LayoutsRelated/mobileHeaders/mobileHeaderwithCancleFunction/MobileHeaderwithCancleFunction";
import HeadingSteps from "@/pages/checkout/shop-apply/shopApplyForm/HeadingSteps/HeadingSteps";
import CancelButton from "@/components/UiKit/Buttons/CancelButton/CancelButton";
import PaymentInfoV2 from "@/pages/checkout/components/PaymentInfo/PaymentInfoV2";
import WarrantySection from "@/pages/checkout/warranty/WarrantySection";
import MobileCarInfoV2 from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfoV2";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import Loader from "@componentsShared/Loader/Loader";
import CreditCardForm from "@/pages/checkout/credit-card/components/CreditCardForm";
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import useBoolean from "@hooks/useBoolean";
import useLocalStorage from "@hooks/useLocalStorage";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { useCreditCardCheckout } from "@/common/Contexts/CreditCardCheckoutContext";
import { handleHasAccountEvent } from "@/utils/common";
import { api__createCreditCardOrderV2 } from "@/apis/orders/orders";
import { dispatchButtonLoading } from "@hooks/useButtonLoading";
import { ValidationException } from "@/common/exceptions/ValidationException";
import { toast } from "sonner";
var CreditCardCheckout = function CreditCardCheckout() {
  var _checkoutOrderV2$post;
  if (__IS_SSR__) return /*#__PURE__*/React.createElement(Loader, null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var _useLocalStorage = useLocalStorage(),
    setLocalStorage = _useLocalStorage.setLocalStorage,
    removeLocalStorage = _useLocalStorage.removeLocalStorage;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var _useState = useState(false),
    showOtp = _useState[0],
    setShowOtp = _useState[1];
  // form payload kept until the order can be created (after OTP — create endpoint needs auth)
  var _useState2 = useState(null),
    pendingPayload = _useState2[0],
    setPendingPayload = _useState2[1];
  var _useCreditCardCheckou = useCreditCardCheckout().state,
    checkoutOrderV2 = _useCreditCardCheckou.checkoutOrderV2,
    formData = _useCreditCardCheckou.formData,
    fetch_loading = _useCreditCardCheckou.fetch_loading;
  var post_id = useCreditCardCheckout().queryParams.post_id;
  var setFormItem = useCreditCardCheckout().actions.setFormItem;
  var _useCreditCardCheckou2 = useCreditCardCheckout().remote_actions,
    fetch__getOrderWithPaymentInfoV2 = _useCreditCardCheckou2.fetch__getOrderWithPaymentInfoV2,
    fetch__getOrderDetailsByParamsV2 = _useCreditCardCheckou2.fetch__getOrderDetailsByParamsV2;
  var grantedPopup = useBoolean();
  useEffect(function () {
    if (checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && checkoutOrderV2.id) {
      fetch__getOrderWithPaymentInfoV2(post_id, {
        order_id: checkoutOrderV2.id
      });
    }
  }, [checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id]);
  var goToPayment = function goToPayment(orderId) {
    navigateToHard("/checkout/create-araboon?post_id=".concat(post_id, "&order_id=").concat(orderId));
  };

  // create the credit-card order (auth is guaranteed here: logged-in, or just verified via OTP)
  var createOrderAndGo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(payload) {
      var otpVerified,
        order,
        orderId,
        _args = arguments,
        _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            otpVerified = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            dispatchButtonLoading(true);
            _context.p = 1;
            _context.n = 2;
            return api__createCreditCardOrderV2(_objectSpread(_objectSpread({}, payload), formData !== null && formData !== void 0 && formData.warranty_id ? {
              warranty_id: Number(formData.warranty_id)
            } : {}));
          case 2:
            order = _context.v;
            orderId = order === null || order === void 0 ? void 0 : order.id;
            if (orderId) {
              _context.n = 3;
              break;
            }
            console.error("credit-card create: unexpected response shape", order);
            toast.error(t("error_occurred_while_creating_request", {
              ns: "web_checkout_cash"
            }), {
              position: "bottom-center"
            });
            setShowOtp(false); // don't leave the user stuck on the OTP loader
            return _context.a(2);
          case 3:
            // the Arboon page (Checkout.tsx) shows the "verify code" step purely from this flag.
            // set it only when OTP actually ran; clear any stale value for logged-in users so the
            // tab doesn't reappear on re-tests of the same order_id.
            if (otpVerified) setLocalStorage("otp_visited_".concat(orderId), "1");else removeLocalStorage("otp_visited_".concat(orderId));
            sessionStorage.setItem("cc_order_".concat(orderId), "1");
            goToPayment(orderId);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            setShowOtp(false);
            if (_t instanceof ValidationException) {
              toast.error(_t.getAllErrorMessages(), {
                position: "bottom-center"
              });
            } else {
              toast.error((_t === null || _t === void 0 ? void 0 : _t.message) || t("error_occurred_while_creating_request", {
                ns: "web_checkout_cash"
              }), {
                position: "bottom-center"
              });
            }
          case 5:
            _context.p = 5;
            dispatchButtonLoading(false);
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4, 5, 6]]);
    }));
    return function createOrderAndGo(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleComplete = function handleComplete(payload, requiresOtp) {
    setPendingPayload(payload);
    if (requiresOtp) {
      setShowOtp(true);
      return;
    }
    createOrderAndGo(payload);
  };
  var verifyOtpCb = function verifyOtpCb(userData) {
    if (!pendingPayload) return;
    handleHasAccountEvent({
      hasAccount: userData.has_account,
      status: "Success",
      phone_number: pendingPayload.phone_number,
      lang: lang,
      referral_location: "credit_card_order"
    });
    createOrderAndGo(pendingPayload, true);
  };
  var main_render = function main_render() {
    if (showOtp) {
      return /*#__PURE__*/React.createElement(OtpVerification, {
        source: "credit_card",
        after_verify_callback: verifyOtpCb,
        scenario: "signup",
        phone_number: pendingPayload === null || pendingPayload === void 0 ? void 0 : pendingPayload.phone_number,
        onEditNumber: function onEditNumber() {
          return setShowOtp(false);
        },
        design: {
          btnText: tShort("phone_number_verification", {
            ns: "otp_screen"
          }),
          label: tShort("enter_code_sent_to", {
            ns: "otp_screen"
          }),
          withborder: false
        }
      });
    }
    return /*#__PURE__*/React.createElement(CreditCardForm, {
      onComplete: handleComplete
    });
  };
  return /*#__PURE__*/React.createElement(Layout, {
    disableLoader: true,
    loading: fetch_loading,
    authenticationMsg: true,
    mainClass: "CheckOut",
    logoNotClickable: true,
    headHideLinks: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeaderwithCancleFunction, {
      title: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post = checkoutOrderV2.post) === null || _checkoutOrderV2$post === void 0 ? void 0 : _checkoutOrderV2$post.post_title,
      buttonFunction: function buttonFunction() {
        if (showOtp) {
          setShowOtp(false);
          return;
        }
        navigateTo("/cardetail/".concat(post_id));
      }
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "container md:py-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:mx-auto md:w-fit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-hide flex justify-start mb-4"
  }, /*#__PURE__*/React.createElement(CancelButton, {
    onClick: function onClick() {
      if (showOtp) {
        setShowOtp(false);
        return;
      }
      navigateToHard("/cardetail/".concat(post_id));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 md:flex-row md:items-start md:gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-[664px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:bg-white md:border md:border-solid md:border-[#d6dfe9] md:rounded-[16px] md:shadow-[0px_0px_5px_rgba(0,0,0,0.1)] md:px-[49px] md:py-[40px]"
  }, /*#__PURE__*/React.createElement(HeadingSteps, {
    className: ""
  }, /*#__PURE__*/React.createElement("span", {
    className: showOtp ? "completed" : "active"
  }, tShort("steps/add_information")), !isLoggedIn && /*#__PURE__*/React.createElement("span", {
    className: showOtp ? "active" : ""
  }, tShort("steps/otp_verification")), /*#__PURE__*/React.createElement("span", null, tShort("steps/payment"))), isMobile && !showOtp && /*#__PURE__*/React.createElement(MobileCarInfoV2, {
    className: "mt-5 mb-6",
    checkoutOrderV2: checkoutOrderV2,
    onClickInfoIcon: grantedPopup.setTrue
  }), isMobile && !showOtp && /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(WarrantySection, {
    checkoutOrderV2: checkoutOrderV2,
    orderType: "credit_card",
    referralLocation: "checkout",
    onWarrantyChange: (/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              setFormItem("warranty_id", id);
              _context2.n = 1;
              return fetch__getOrderDetailsByParamsV2(post_id, {
                warranty_id: id,
                city_id: Number((formData === null || formData === void 0 ? void 0 : formData.city_id) || "")
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }())
  })), main_render())), isDesktop && /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-container",
    className: "m-hide w-full md:w-[468px]"
  }, /*#__PURE__*/React.createElement(PaymentInfoV2, {
    loading: !checkoutOrderV2,
    checkoutOrderV2: checkoutOrderV2,
    onClickInfoIcon: grantedPopup.setTrue,
    orderType: "credit_card",
    showWarrantyWidget: isDesktop && !showOtp,
    onWarrantySelected: (/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
        var key, existing;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              setFormItem("warranty_id", id);
              // persist under the credit-card key so the selection survives
              // back-navigation from Arboon and stays independent of the cash flow
              try {
                key = "credit_card_form_data_".concat(post_id);
                existing = JSON.parse(sessionStorage.getItem(key) || "{}");
                sessionStorage.setItem(key, JSON.stringify(_objectSpread(_objectSpread({}, existing), {}, {
                  warranty_id: id
                })));
              } catch (_unused) {}
              _context3.n = 1;
              return fetch__getOrderDetailsByParamsV2(post_id, {
                warranty_id: id,
                city_id: Number((formData === null || formData === void 0 ? void 0 : formData.city_id) || "")
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }())
  }))))));
};
export default CreditCardCheckout;